import to from "await-to-js";
import { List, Skeleton } from "antd";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import storage from "../../../utils/storage";
import { IUserCompany } from "../../../modules/auth/auth.types";
import { AuthContext } from "../../../modules/auth/auth.context";
import { authService } from "../../../modules/auth/auth.service";
import { UserRoles } from "../../../modules/auth/auth.constants";
import { CompanyIcon } from "../../../components/CompanyIcon/CompanyIcon";

import style from "./ChooseCompany.module.scss";
import { ModalsContext } from "../../../context/modals.context";
import { useTranslation } from "react-i18next";

export const ICON_COLORS = [
  "#FA541C",
  "#5196F3",
  "#A0D911",
  "#EB2F96",
  "#722ED1",
  "#430A5D",
  "#4CCD99",
  "#FFC700",
  "#891652",
];

export const ChooseCompany = () => {
  const { fetchUserCompanies, auth, setAuth } = useContext(AuthContext);
  const { startLoader, endLoader, setError } = useContext(ModalsContext);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const getUserRoles = async () => {
    const [err, res] = await to(authService.getUserRoles());
    if (err || !res.success) return setError(res?.errorMessage);
    const activeUserRoles = res.data.roles
      .filter((r) => r.aktivno)
      .map((r) => r.name);
    setAuth({
      allUserRoles: activeUserRoles,
      showAddDrustvo: res.data.showAddDrustvo,
    });
    startLoader();
    authService.setShowAddDrustvo(res.data.showAddDrustvo);
    authService.setRole(activeUserRoles);
    endLoader();
    navigate("/obveznik/podesavanja");
  };

  const handleClick = async (company: IUserCompany) => {
    const [err, res] = await to(authService.selectUserCompany(company.id));
    if (err || !res.success) return setError(res?.errorMessage);
    storage.setItem("userCompanyName", company.naziv);
    storage.setItem("userCompanyId", company.id as any);

    authService.setRole([UserRoles.Obveznik]);
    getUserRoles();
  };

  useEffect(() => {
    fetchUserCompanies();
  }, []);

  return (
    <div className={style.container}>
      <div className={style.listWrapper}>
        <h1>{t("COMMON.SUBJEKTI")}</h1>

        <List
          className="demo-loadmore-list"
          loading={false}
          itemLayout="horizontal"
          loadMore={false}
          dataSource={auth.userCompanyList}
          renderItem={(company, i) => (
            <List.Item
              actions={[<span className={style.link}>Izaberi</span>]}
              className={style.listItem}
              onClick={() => handleClick(company)}
            >
              <Skeleton avatar title={false} loading={false} active>
                <List.Item.Meta
                  className={style.listItemContent}
                  avatar={<CompanyIcon bgColor={ICON_COLORS[i]} />}
                  title={<span>{company.naziv}</span>}
                  description={company.pib}
                />
              </Skeleton>
            </List.Item>
          )}
        />
      </div>
    </div>
  );
};
